import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AccountLayout from "../components/AccountLayout";
import { api } from "../lib/api";

const STATUS_LABELS = {
  placed: "PLACED",
  confirmed: "CONFIRMED",
  printed: "PRINTED",
  shipped: "SHIPPED",
  delivered: "DELIVERED",
};

export default function MyOrders({ past = false }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, []);

  const list = past
    ? orders.filter((o) => o.status === "delivered")
    : orders.filter((o) => o.status !== "delivered");

  const title = past ? "Past Orders" : "Active Orders";
  const subtitle = past ? "Delivered & archived" : "In progress — placed, confirmed, printed or shipped";

  return (
    <AccountLayout>
      <div className="flex items-end justify-between flex-wrap gap-4 mb-6">
        <div>
          <p className="label-mono text-[#71717A]">// {past ? "HISTORY" : "ACTIVE"}</p>
          <h2 className="font-display font-black text-3xl uppercase mt-2">{title}</h2>
          <p className="text-[#A1A1AA] text-sm mt-1">{subtitle}</p>
        </div>
        <p className="label-mono text-[#71717A]">{list.length} ORDER{list.length !== 1 ? "S" : ""}</p>
      </div>

      {loading ? (
        <p className="label-mono text-[#71717A]">// LOADING...</p>
      ) : list.length === 0 ? (
        <div className="border border-[#27272A] py-20 text-center" data-testid="orders-empty">
          <p className="label-mono text-[#71717A]">// {past ? "NO PAST ORDERS YET" : "NO ACTIVE ORDERS"}</p>
          <Link to="/shop" className="btn-neon mt-6 inline-flex">START SHOPPING</Link>
        </div>
      ) : (
        <div className="space-y-4">
          {list.map((o) => (
            <Link
              key={o.id}
              to={`/orders/${o.id}`}
              className="block border border-[#27272A] p-6 hover:border-[#CFF048] transition-colors"
              data-testid={`order-card-${o.id}`}
            >
              <div className="flex flex-wrap justify-between items-start gap-4">
                <div>
                  <p className="label-mono text-[#71717A]">ORDER // {o.id.slice(0, 8).toUpperCase()}</p>
                  <p className="font-display font-bold text-lg mt-2">
                    {o.items.length} item{o.items.length > 1 ? "s" : ""} // ₹{o.total.toFixed(2)}
                  </p>
                  <p className="label-mono text-[#71717A] mt-1">{new Date(o.created_at).toLocaleDateString()}</p>
                </div>
                <div className="text-right">
                  <span className="sticker text-[#CFF048] border-[#CFF048]">{STATUS_LABELS[o.status] || o.status.toUpperCase()}</span>
                  <p className="label-mono mt-2">PAYMENT // {(o.payment_status || "pending").toUpperCase()}</p>
                  {o.tracking_number && (
                    <p className="label-mono mt-1 text-[#CFF048]">{o.courier_name} // {o.tracking_number}</p>
                  )}
                </div>
              </div>
              <div className="flex gap-2 mt-4 overflow-x-auto">
                {o.items.slice(0, 6).map((it, i) => (
                  <img key={i} src={it.image} alt="" className="w-14 h-14 object-cover border border-[#27272A]" />
                ))}
              </div>
            </Link>
          ))}
        </div>
      )}
    </AccountLayout>
  );
}
